import React, { ReactNode } from "react";

interface TextProps {
    type?: "H1" | "H2" | "T1" | "T2" | "T3" | "B1" | "B2" | "B3" | "L1" | "L2";
    color?: string;
    additonalStyle?: string;
    children: ReactNode;
}

const Text: React.FC<TextProps> = ({
    type = "B2",
    color = "#190A28",
    children,
    additonalStyle,
}) => {
    const getTextStyle = () => {
        switch (type) {
            case "H1":
                return "text-[24px] leading-[32px] font-bold";
            case "H2":
                return "text-[20px] leading-[28px] font-bold";
            case "T1":
                return "text-[16px] leading-[24px] font-semibold";
            case "T2":
                return "text-[14px] leading-[20px] font-semibold";
            case "T3":
                return "text-[12px] leading-[16px] font-semibold";
            case "B1":
                return "text-[16px] leading-[24px] font-normal";
            case "B2":
                return "text-[14px] leading-[20px] font-normal";
            case "B3":
                return "text-[12px] leading-[16px] font-normal";
            case "L1":
                return "text-[10px] leading-[12px] font-bold";
            case "L2":
                return "text-[10px] leading-[12px] font-bold";
            default:
                return "";
        }
    };

    const textStyle = `font-inter ${getTextStyle()}`;

    return (
        <span className={`${textStyle} ${additonalStyle}`} style={{ color: color }}>
            {children}
        </span>
    );
};

export default Text;
